import { WardrobeObject } from '@/Engine/Wardrobe/WardrobeObject';
import { iApp } from '@/Interfaces/app';
import { Window } from '@/Engine/Window';
import { Door } from '@/Engine/Door';
import { engineConfig } from '@/Constants/3dConfig';
import { $ } from '@/Engine/stateInstance';
import { Box3Helper, Color } from 'three';

export const addBoxHelpers = (objects: Array<WardrobeObject | Window | Door>) => {
    if (!engineConfig.boxHelper) return;
    // app.scene.children.forEach((child)=>{
    //     if (child.type === 'Box3Helper') app.scene.remove(child);
    // });
    objects.forEach((module: WardrobeObject | Window | Door)=> {
        const helper = new Box3Helper(module.box, new Color(0xffff00));
        $.app.scene.add(helper);
    });
};

export function removeBoxHelpers() {
    if (!engineConfig.boxHelper) return;
    $.app.scene.children.forEach((child)=>{
        if (child.type === 'Box3Helper') $.app.scene.remove(child);
        if (child.name.includes('temp')) $.app.scene.remove(child);
    });
}
